import { defineStore } from "pinia";

function weaponsMatch(a, b) {
  if (a.material.name !== b.material.name) return false;
  if (a.subtype.name !== b.subtype.name) return false;
  const aRolls = Object.keys(a.rolls);
  const bRolls = Object.keys(b.rolls);
  if (aRolls.length !== bRolls.length) return false;
  for (const key of aRolls) {
    if (a.rolls[key] !== b.rolls[key]) return false;
  }
  return true;
}

export const useInventoryStore = defineStore("inventory", {
  state: () => ({
    items: [],
    materials: {},
    sortBy: "",
    filterMaterial: "",
    filterSubtype: "",
  }),
  actions: {
    addItem(item) {
      const existing = this.items.find((i) => weaponsMatch(i, item));
      if (existing) {
        existing.quantity = (existing.quantity || 1) + 1;
      } else {
        item.quantity = 1;
        this.items.push(item);
      }
    },
    removeItem(index) {
      const item = this.items[index];
      if (item.quantity > 1) {
        item.quantity--;
      } else {
        this.items.splice(index, 1);
      }
    },
    addMaterial(materialName, amount = 1) {
      if (!this.materials[materialName]) {
        this.materials[materialName] = 0;
      }
      this.materials[materialName] += amount;
    },
    smeltItem(index) {
      const item = this.items[index];
      this.addMaterial(item.material.name);
      this.removeItem(index);
    },
    consolidateItems() {
      const consolidated = [];
      for (const item of this.items) {
        const existing = consolidated.find((i) => weaponsMatch(i, item));
        if (existing) {
          existing.quantity = (existing.quantity || 1) + (item.quantity || 1);
        } else {
          item.quantity = item.quantity || 1;
          consolidated.push(item);
        }
      }
      this.items = consolidated;
    },
  },
});
